import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {FullLayoutComponent} from './core/containers/full-layout/full-layout.component';
import {SimpleLayoutComponent} from './core/containers/simple-layout/simple-layout.component';
import {AuthGuardService} from './core/service/auth-guard.service';
import {APP_ROUTES} from './app.routes';
import {LoginComponent} from './core/components/login/login.component';
import {DashboardComponent} from './core/components/dashboard/dashboard.component';

export const routes: Routes = [
    {
        path: '',
        component: FullLayoutComponent,
        data: {
            title: 'Home'
        },
        canActivate: [AuthGuardService],
        children: APP_ROUTES
    },
    {
        path: 'pages',
        component: SimpleLayoutComponent,
        data: {
            title: 'Pages'
        },
        children: [
            {
                path: 'login',
                component: LoginComponent,
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash: true})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/app.routing.ts